import React, { useState } from 'react';
import Faqimg from '../../assets/images/faqimag.jpg';
import { FaChevronDown, FaChevronRight, FaEdit } from "react-icons/fa";
import workwiseLogo from '../../assets/images/workwise-logo-white.png';
import { NavLink } from 'reactstrap';

function Faq() {
      const [productisOpen1, productsetIsOpen1] = useState(1);
      const toggleSection = (sectionNumber) => {
        productsetIsOpen1(productisOpen1 === sectionNumber ? 0 : sectionNumber);
      };
      const faqData = [
            { question: "How To Login Your Account?",  },
            { question: "How To Register Your Account?", },
            { question: "How To Set New Password Using Forgot Password?", },
            { question: "How To Add Project?",},
            { question: "How To Add Milestone?", },
            { question: "How To Add Task Group?",},
            { question: "How To Add Task?", },
            { question: "How To Change Personal Information & Password?", },
            { question: "How To Add Portal/Client Users?", },
            { question: "How To Add Company?",},
            { question: "How To Add Bussiness Unit?", },
            { question: "How To Add Department?", },
          ];
  return (
    <>
       <div  id="faq-sec" className="Almuni ">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="login-img">
                                <div className="loginvedio">
                                    <img src={Faqimg} alt="Login Images" />
                                </div>
                                <div className="mask" >
                                    <div className="mask-in">
                                        <img src={workwiseLogo} alt="ProjectWise Management Software" />
                                        <h1>Frequently Asked Questions</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                  <div className="col-lg-8 col-md-6">
                        <div id="faq-wrap">
                            <h4>FAQs</h4>
                        {faqData.map((faq, index) => (
                        <div className="faq-main" key={index}>
                              <div className="dropdown">
                              {productisOpen1 === index + 1 ? (
                              <FaChevronDown onClick={() => toggleSection(index + 1)} />
                              ) : (
                              <FaChevronRight onClick={() => toggleSection(index + 1)} />
                              )}
                              <span>{faq.question}</span>
                              </div>
                              <div className={productisOpen1 === index + 1 ? "productlist-open" : "product-list"}>
                              <div className="projectwisedetail-wrap">
                              <NavLink to={faq.videoLink}>
                                    <video width="600" controls>
                                    <source src={faq.videoSrc} type="video/mp4" />
                                    </video>


                              </NavLink>
                              </div>
                              </div>
                        </div>
                        ))}
                        </div>
                  </div>
                </div>
                </div>
       </div>                
    </>
  )

}

export default Faq